// services/produtos/ProdutoConjuntoService.js
import { fetchData, postData, putData, deleteData } from '../Api';

export const buscarConjuntosDetalhados = async () => {
    return await fetchData('/ProdutoConjunto/Conjuntos', { somenteVinculos: true });
};

export const adicionarProdutoConjunto = async (item) => {
    return await postData('/ProdutoConjunto', item);
};

export const alterarProdutoConjunto = async (item) => {
    return await putData('/ProdutoConjunto', item);
};

export const excluirProdutoConjunto = async (id) => {
    return await deleteData('/ProdutoConjunto', { id });
};
